export default __webpack_public_path__ + "static/media/periscope.22a46d74.svg";